import { STORE_SELECTED_LANGUAGE } from '../actions/types/languageActionTypes';
import { getProperty } from '../../../../services/PropertiesService';

export default (state = { lang: getProperty('REACT_APP_DEFAULT_LANGUAGE') }, action) => {
  switch (action.type) {
    case STORE_SELECTED_LANGUAGE:
      return { lang: action.payload };
    default:
      return state;
  }
};
